import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {Route, Redirect} from 'react-router-dom';
import './App.css';
import HeroImage from './heroImage';
import Timeline from './timeline.jsx';
import Login from './login.jsx';

class App extends Component {
    constructor() {
      super();
      this.state = {
        passV : sessionStorage.getItem('gozu')
      }
    }

  render() {
    return (
      <Router>
        <section>
          <Route path="/" render={
              ()=>{
                if(this.state.passV == 'OTk0MDc3MDA2MA=='){
                  return(
                    <Redirect from="/" to="/doc"/>
                  )
                }
                else {
                  return(
                    <Login/>
                  )
                }
              }
            }/>
        <Route path="/doc" render={
        ()=>{
            if(this.state.passV == 'OTk0MDc3MDA2MA=='){
              return(
              <section>
                <HeroImage/>
                <Timeline/>
              </section>
            )
            }
            else {
              return(
                <Redirect from="/doc" to="/"/>
            )
            }
        }
      }/>
        </section>
      </Router>
      // <div className="App">
      //   <header className="App-header">
      //     <img src={logo} className="App-logo" alt="logo" />
      //     <h1 className="App-title">Welcome to React</h1>
      //   </header>
      //   <p className="App-intro">
      //     To get started, edit <code>src/App.js</code> and save to reload.
      //   </p>
      // </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js